import { Container } from '@mui/material';

import ErrorBoundary from '@cvt/components/ErrorBoundary';

import { Majors as MajorsView } from '@modules/Majors/views/Majors';

export const Majors = () => {

  return (
    <Container
      maxWidth="sm"
      sx={{
        py: 3,
      }}
    >
      <ErrorBoundary>
        <MajorsView />
      </ErrorBoundary>
    </Container>
  );
};
